import { DepartureCommittedSearch } from '~/components/Cruises/components/shared/DepartureGridConfig';

import type { DepartureSort } from './useGetDepartures';

export const departureQueryKeys = {
  all: ['departures'] as const,
  lists: () => [...departureQueryKeys.all, 'list'] as const,
  list: (search: DepartureCommittedSearch | null, page: number, pageSize: number, sort: DepartureSort) =>
    [...departureQueryKeys.lists(), search, page, pageSize, sort] as const,
  dataFeed: (departureId: string, cruiseType: string, date?: string) =>
    [...departureQueryKeys.all, departureId, 'data-feed', cruiseType, date] as const,
};
